import { expand, EMPTY, skip, reduce, of, Observable } from 'rxjs';
import { IClientApiDependencySegment, IApiLpSymbol } from '@cbridge-packages/api';
import { IClientLp } from '@cbridge-packages/lp-client';
import { fetchUnmappedSymbolsLp, IUnmappedSymbolsQueryParams } from './fetchUnmappedSymbolsLp';

type IDependencies =
  & IClientApiDependencySegment;

export const fetchUnmappedSymbolsLpRecursively = (
  lpId: IClientLp['lpId'],
  initialQueryParams: IUnmappedSymbolsQueryParams,
  dependencies: IDependencies,
): Observable<IApiLpSymbol[]> => {
  return of(initialQueryParams).pipe(
    expand(({ limit, skip, search, isLastPage }) => {
      return isLastPage
        ? EMPTY
        : fetchUnmappedSymbolsLp(lpId, { limit, skip, search }, dependencies);
    }),
    skip(1),
    reduce((lpSymbols, { lpSymbols: nextSymbols }) => {
      return lpSymbols.concat(nextSymbols);
    }, [] as IApiLpSymbol[]),
  );
};
